import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  quote: 'En tres semanas de aplicar las herramientas del Volumen 2 logré que una persona que llevaba cuatro encuentros en silencio total empezara a hablar de lo que realmente le pasaba. Nunca pensé que iba a tener algo tan concreto para usar en ese momento.',
  name: 'Claudia R.',
  location: 'Buenos Aires',
  role: 'Orientadora en adicciones en ONG'
}, {
  quote: 'El protocolo de recaída me cambió completamente la forma de trabajar. Antes cuando alguien recaía no sabía si confrontar, contener o qué. Ahora tengo un mapa claro para ese momento y la persona no desaparece del proceso.',
  name: 'Marcelo T.',
  location: 'Rosario',
  role: 'Acompañante terapéutico en comunidad'
}, {
  quote: 'Las fichas del Bono 3 las imprimo antes de cada encuentro. Me ahorran una hora de preparación por semana y me hacen sentir mucho más seguro de lo que hago. Vale lo que vale y más.',
  name: 'Valeria M.',
  location: 'Córdoba',
  role: 'Orientadora independiente en adicciones conductuales'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-10 md:py-20 px-4 bg-white overflow-hidden" data-id="element-336">
      <div className="max-w-7xl mx-auto" data-id="element-337">
        {/* Desktop Grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-8" data-id="element-338">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-light p-6 rounded-lg border-l-4 border-gold shadow-sm flex flex-col h-full" data-id="element-339">
              <div className="flex gap-1 mb-4" data-id="element-340">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-341" />)}
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed italic flex-grow" data-id="element-342">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-3 mt-auto" data-id="element-343">
                <div className="w-12 h-12 rounded-full bg-navy-base text-cream-bg flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-344">
                  {testimonial.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div data-id="element-345">
                  <div className="font-semibold text-navy-dark" data-id="element-346">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-347">
                    {testimonial.location}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-348">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden relative" data-id="element-349">
          <div className="overflow-hidden px-2 py-4" data-id="element-350">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -50
          }} transition={{
            duration: 0.3
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.2} onDragEnd={(e, {
            offset,
            velocity
          }) => {
            const swipe = Math.abs(offset.x) * velocity.x;
            if (swipe < -100) next();else if (swipe > 100) prev();
          }} className="bg-cream-light p-5 rounded-lg border-l-4 border-gold shadow-md" data-id="element-351">
              <div className="flex gap-1 mb-3" data-id="element-352">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-353" />)}
              </div>

              <p className="text-gray-700 mb-5 leading-relaxed italic text-sm" data-id="element-354">
                "{testimonials[currentIndex].quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-355">
                <div className="w-10 h-10 rounded-full bg-navy-base text-cream-bg flex items-center justify-center font-bold text-base flex-shrink-0" data-id="element-356">
                  {testimonials[currentIndex].name.split(' ').map(n => n[0]).join('')}
                </div>
                <div data-id="element-357">
                  <div className="font-semibold text-navy-dark text-sm" data-id="element-358">
                    {testimonials[currentIndex].name}
                  </div>
                  <div className="text-xs text-gray-600" data-id="element-359">
                    {testimonials[currentIndex].location}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-2" data-id="element-360">
            <button onClick={prev} className="p-2 rounded-full bg-gray-100 text-navy-dark hover:bg-gray-200" data-id="element-361">
              <ChevronLeft className="w-5 h-5" data-id="element-362" />
            </button>
            <div className="flex gap-2" data-id="element-363">
              {testimonials.map((_, idx) => <div key={idx} className={`w-2 h-2 rounded-full transition-colors ${idx === currentIndex ? 'bg-gold' : 'bg-gray-300'}`} data-id="element-364" />)}
            </div>
            <button onClick={next} className="p-2 rounded-full bg-gray-100 text-navy-dark hover:bg-gray-200" data-id="element-365">
              <ChevronRight className="w-5 h-5" data-id="element-366" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}